import { fitBounds } from "google-map-react/utils";
import GoogleMapReact from "google-map-react";
import React, { Component } from "react";
import styled from "styled-components";

import PropTypes from "prop-types";

import { above, below } from '../style/functions';
import downIcon from "../images/carat.svg"

function getBounds(points, mapElement) {
  const size = mapElement.getBoundingClientRect()
  let bounds = {
    nw: { lat: points[0].lat, lng: points[0].lng },
    se: { lat: points[0].lat, lng: points[0].lng }
  }

  const { nw, se } = bounds
  for( let point of points ) {
    nw.lat = Math.max(nw.lat, point.lat)
    se.lat = Math.min(se.lat, point.lat)
    nw.lng = Math.min(nw.lng, point.lng )
    se.lng = Math.max(se.lng, point.lng )
  }

  return fitBounds(bounds, size)
}

const MainLocationMarker = ({ icon }) => (
  <div className="main-location">
    <img src={icon} alt="Main Location"/>
  </div>
);

const LocationMarker = ({ icon, hover, text }) => (
  <div className="marker" style={{ backgroundImage: `url(${icon})` }}>
    {hover && <div className="popover">{text}</div>}
  </div>
);

class Map extends Component {

  constructor(props) {
    super(props)
    this.mapElement = React.createRef()
    this.state = {
      hoverKey: null,
      zoom: 15,
    };
  }

  componentDidMount() {
    const props = this.props
    const location = props.locations[0]
    this.setState({
      selectedLocationType: location.type,
      ...getBounds([...location.points, props.mainLocation], this.mapElement.current)
    })
  }

  onChildMouseEnter = (key /*, childProps */) => {
    this.setState({ ...this.state, hoverKey: key.toString() });
  };

  onChildMouseLeave = (/* key, childProps */) => {
    this.setState({ ...this.state, hoverKey: null });
  };

  onChange = ({ center, zoom, bounds, ...others }) => {
    this.setState({ ...this.state, zoom });
  };

  render() {
    const { locations, mainLocation, majorPin, minorPin } = this.props;
    const { center, hoverKey, selectedLocationType, zoom } = this.state;
    const selectedType = locations.find(
      item => item.type === selectedLocationType
    );

    const header = (
      <div>
        <select 
          onChange={e => {
            const location = locations[e.target.value]
            this.setState({ 
              ...this.state, 
              selectedLocationType: location.type, 
              ...getBounds([...location.points, mainLocation], this.mapElement.current) 
            })
          }}
        >
          {locations.map((location, l) => <option key={location.type} value={l}>{location.type}</option>)}
        </select>
        {locations.map(location => (
          <div
            key={location.type}
            className={"row " + (location.type === selectedLocationType ? "active" : "")}
            onClick={() => this.setState({ ...this.state, selectedLocationType: location.type, ...getBounds([...location.points, mainLocation], this.mapElement.current) })}
          >
            <span>
              {location.type}
            </span>
          </div>
        ))}
      </div>
    );

    const markers =
      selectedType &&
      selectedType.points.map((location, index) => {
        const { ...coords } = location;

        return (
          <LocationMarker
            key={index}
            {...coords}
            text={location.name}
            hover={hoverKey === index.toString()}
            icon={minorPin}
          />
        );
      });

    return (
      <MapWrapper>
        <div className="header">{header}</div>
        <div className="google-map-container" ref={this.mapElement}>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: "AIzaSyBmqAbo4c75obAr-K_w2WvDmibxo0b-PyQ"
            }}
            center={center}
            defaultOptions={{ 
              styles: [
                { featureType: "all", elementType: "labels.text", stylers: [{ visibility: "off" }] }
              ]
            }}
            zoom={zoom}
            onChildMouseEnter={this.onChildMouseEnter}
            onChildMouseLeave={this.onChildMouseLeave}
            onChange={this.onChange}
            options={this.createMapOptions}
          >
            <MainLocationMarker icon={majorPin} lat={mainLocation.lat} lng={mainLocation.lng} />
            {markers}
          </GoogleMapReact>
        </div>
      </MapWrapper>
    );
  }

  createMapOptions = maps => {
    return {
      panControl: false,
      mapTypeControl: false,
      scrollwheel: false,
      styles: [
        { featureType: "poi", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
        {
          "featureType": "landscape",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#f9f7f0"
            }
          ]
        },
        {
          "featureType": "landscape.natural.landcover",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "landscape.natural.terrain",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi.attraction",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi.business",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi.government",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi.medical",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "stylers": [
            {
              "color": "#c3ecd0"
            }
          ]
        },
        {
          "featureType": "poi.place_of_worship",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi.school",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi.sports_complex",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#c3ecd0"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#e4e2dd"
            },
            {
              "lightness": 60
            },
            {
              "weight": 1
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#c6c6c5"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#f1eee2"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#c6beb5"
            },
            {
              "lightness": 55
            },
            {
              "weight": 1.5
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        }
      ]
    };
  };
}

const MapWrapper = styled.div`
  select {
    background: none;
    border: none;
    color: inherit;
    text-transform: uppercase;
    font-weight: normal;
    width: 100%;
    height: 100%;
    height: 3rem;
    appearance: none;
    background: url(${downIcon}) 98% 50% no-repeat;
    background-size: 12px 12px;
    margin: 0;
    padding: 0 1rem;
  }

  .header {
    display: flex;
    flex-direction: row;

    > div {
      display: flex;
      flex-direction: row;
    }

    > div {
      background-color: #F0F0F0;
      width: 100%
    }

    > div > div {
      flex: 1 0;
      padding: 17px 0px 13px;
      line-height: 1;
      text-align: center;
      text-transform: uppercase;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    ${above.mobile`
      select { display: none; }
    `}
    ${below.mobile`
      > div > div {
        display: none;
      }
    `}

    .active {
      background-color: #E0E0E0;
      font-weight: bold;
    }
  }
  .main-location {
    font-size: 1rem;
    width: 12em;
    // padding: 1em 1.2em;
    // background: #000;
    transform: translateX(-50%) translateY(-100%);
    // margin-top: -1em;
    position: relative;

    // :after {
    //   content: "";
    //   display: block;
    //   position: absolute;
    //   top: 100%;
    //   left: 50%;
    //   margin-left: -1.4em;
    //   margin-top: -1px;
    //   border: 1.4em solid transparent;
    //   border-top-color: #000;
    // }
  }
  .google-map-container {
    font-size: 20em;
    color: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 70vh;
    background: #89bcb3;

    .marker {
      width: 30px;
      height: 30px;
      position: relative;
      margin: -15px;

      .popover {
        color: white;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 100%;
        font-weight: 500;
        background-color: rgba(0, 0, 0, 0.85);
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
        padding: 1.2rem 10px;
        text-transform: uppercase;
        letter-spacing: 0.2em;
        line-height: 1rem;
        width: 180px;
        max-width: 180px;
        text-align: center;
        z-index: 4;
        &:before {
          border-top: 7px solid rgba(0, 0, 0, 0.85);
          border-right: 7px solid transparent;
          border-left: 7px solid transparent;
          bottom: -7px;
          content: "";
          display: block;
          left: 50%;
          margin-left: -7px;
          position: absolute;
        }
      }
    }
  }
`;

// @NOTE: please adhere to these propTypes
Map.propTypes = {
  mainLocation: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }).isRequired,
  majorLocationPin: PropTypes.arrayOf({
    url: PropTypes.string,
  }),
  minorLocationPin: PropTypes.arrayOf({
    url: PropTypes.string,
  }),
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      points: PropTypes.arrayOf(
        PropTypes.shape({
          lat: PropTypes.number,
          lng: PropTypes.number
        })
      )
    })
  ).isRequired
};

export default Map;
